export interface PageHeroData {
  title: string
  description: string
  backgroundImage: string
}

// Hinweis: Die Hero-Hintergründe verweisen auf lokale Banner in /public/images/home/hero.
// Früher zeigten sie auf https://www.mobi-kart.de/assets/images/Gallery/Gallery/Mobikart-Kartbahn-*.jpg
// – dieser (alte) Pfad liefert inzwischen durchgängig 404 (siehe /buchen). Lokale Banner sind
// zuverlässig und werden mit der App ausgeliefert.
export const pageHeroData: Record<string, PageHeroData> = {
  bilder: {
    title: "Bildergalerie",
    description: "Entdecke Eindrücke unserer Kartbahn mit Bildern aus allen Bereichen",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
  buchen: {
    title: "Buche deine Rennzeit",
    description: "Wähle deinen Wunschtermin und sichere dir einen Platz auf unserer Kartbahn",
    backgroundImage: "/images/home/hero/banner2.jpg",
  },
  preise: {
    title: "Unsere Preise",
    description: "Faire Preise für maximalen Rennspaß auf unseren Kartbahnen",
    backgroundImage: "/images/home/hero/banner3.jpg",
  },
  karts: {
    title: "Unsere Karts",
    description: "Modernste Elektro-Karts für ein einzigartiges Fahrerlebnis",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
  geburtstag: {
    title: "Kindergeburtstag feiern",
    description: "Unvergessliche Geburtstagsfeiern mit Rennspaß für die ganze Gruppe",
    backgroundImage: "/images/home/hero/banner2.jpg",
  },
  news: {
    title: "Neuigkeiten",
    description: "Aktuelle Informationen und Angebote rund um MOBIKART",
    backgroundImage: "/images/home/hero/banner3.jpg",
  },
  faq: {
    title: "Häufig gestellte Fragen",
    description: "Antworten auf die wichtigsten Fragen zu unserem Angebot",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
  kontakt: {
    title: "Kontakt",
    description: "So erreichst du uns - wir freuen uns auf deine Nachricht",
    backgroundImage: "/images/home/hero/banner2.jpg",
  },
  kartschule: {
    title: "Kartschule",
    description: "Lerne die Grundlagen des Kartfahrens – von der Bremsübung bis zur perfekten Kurventechnik",
    backgroundImage: "/images/home/hero/banner3.jpg",
  },
  boerse: {
    title: "Slotbörse",
    description: "Last-Minute-Slots zu reduzierten Preisen – je näher der Start, desto günstiger!",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
  gutschein: {
    title: "Gutscheine",
    description: "Verschenke unvergessliche Rennmomente – als E-Mail-Gutschein oder edle PVC-Karte",
    backgroundImage: "/images/home/hero/banner2.jpg",
  },
  bewertungen: {
    title: "Kundenbewertungen",
    description: "Echte Erfahrungen unserer Gäste – ungeschönt und direkt nach der Fahrt",
    backgroundImage: "/images/home/hero/banner3.jpg",
  },
  aktionen: {
    title: "Aktionen & Rabatte",
    description: "Aktuelle Preisvorteile und Gutscheincodes – sichere dir den besten Preis für deine Fahrt",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
  admin: {
    title: "Admin-Bereich",
    description: "Verwalte die Zeitslots und Kapazitäten für beide Kartbahnen",
    backgroundImage: "/images/home/hero/banner1.jpg",
  },
}
